/**
 * The red star after a field a form cannot be saved without (Emile's QA,
 * 2026-10-18: *"remove optional across all the app and add a red star next to
 * mandatory fields"*).
 *
 * **The star marks what is required; nothing marks what is not.** Every
 * "Optional" tag the app used to print is gone, so a label with no star is a
 * field that may be left empty. The star is hidden from screen readers, which
 * read the label's own `required` (or the field's) instead of "star".
 *
 * Styled by the global `.required-mark` in `index.css`, so any label in any
 * CSS module can carry it without a class of its own.
 */
export function RequiredMark(): React.JSX.Element {
  return (
    <span className="required-mark" aria-hidden="true">
      *
    </span>
  );
}
